import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import { withAuthenticator } from 'aws-amplify-react';

const AppWithAuth = withAuthenticator(App);
// const AppWithAuth = withAuthenticator(App, { includeGreetings: true });

const federated = {
  google_client_id: '502764949619-drheiq365sovvdkvab4t2h8cegpc3ero.apps.googleusercontent.com',
  facebook_app_id: '1823343171304620'
};

ReactDOM.render(<AppWithAuth federated={federated}/>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js